module.exports = (__webpack_require__(0))(25);


//////////////////
// WEBPACK FOOTER
// delegated ./src/constants.js from dll-reference girder_plugin_large_image
// module id = 21
// module chunks = 0